import { render, staticRenderFns } from "./pageIntro2ai.vue?vue&type=template&id=0535e07b&scoped=true&"
import script from "./pageIntro2ai.vue?vue&type=script&lang=js&"
export * from "./pageIntro2ai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535e07b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
